import React from 'react'
import { User, Tenant } from 'types'
import {
  AppBar,
  Box,
  Breadcrumbs,
  Button,
  Grid,
  Link,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  Typography,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import AssessmentIcon from '@mui/icons-material/Assessment'
import PersonIcon from '@mui/icons-material/Person'
import { NAVBAR_HEIGHT } from 'components/Navbar'
import { HEADER_HEIGHT } from 'components/ReportHeader'

type Props = {
  currentUser: User
  tenant: Tenant
  reportId: string
  reportTitle: string
}

const PdfReportNavbar: React.FC<Props> = ({
  currentUser,
  tenant,
  reportId,
  reportTitle,
}) => {
  const isYouthtruth = tenant?.body_class === 'youthtruth_subdomain'
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          elevation={0}
          sx={{ backgroundColor: isYouthtruth ? 'white' : 'primary' }}
        >
          <Toolbar
            sx={{
              height: NAVBAR_HEIGHT,
              py: 2,
              backgroundColor: isYouthtruth ? 'white' : 'primary',
              borderBottom: isYouthtruth ? `1px solid ${grey[300]}` : '',
            }}
          >
            <Link href="/">
              <Box
                component="img"
                src={isYouthtruth ? '/YT_Logo.png' : '/cep-logo-white.svg'}
                sx={{
                  height: isYouthtruth ? NAVBAR_HEIGHT - 30 : '100%',
                  position: 'relative',
                  top: isYouthtruth ? 10 : 0,
                }}
              />
            </Link>
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              {currentUser && !currentUser?.public && !currentUser?.admin && (
                <Button
                  component={Link}
                  href="/"
                  sx={{
                    color: isYouthtruth ? 'primary' : '#fff',
                    mr: 2,
                    fontWeight: 'bold',
                  }}
                  startIcon={
                    <AssessmentIcon sx={{ color: 'secondary.light' }} />
                  }
                >
                  My Reports
                </Button>
              )}
              {currentUser && !currentUser?.public && !currentUser?.admin && (
                <>
                  <Button
                    sx={{ color: isYouthtruth ? 'primary' : '#fff', mr: 2 }}
                    startIcon={<PersonIcon />}
                    id="account-menu-button"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                  >
                    Account
                  </Button>
                  <Menu
                    id="account-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      'aria-labelledby': 'account-menu-button',
                    }}
                  >
                    <MenuItem component="a" href="/client/edit">
                      Change Password
                    </MenuItem>
                    <MenuItem
                      component="a"
                      href="/clients/account_two_factor/edit"
                    >
                      Manage Two-Factor Authentication
                    </MenuItem>
                    <MenuItem component="a" href="/clients/sign_out">
                      Sign Out
                    </MenuItem>
                  </Menu>
                </>
              )}
            </Box>
          </Toolbar>
        </AppBar>
        <Box sx={{ height: NAVBAR_HEIGHT }} />
      </Box>
      <Paper
        square
        sx={{
          position: 'fixed',
          width: '100%',
          px: 3,
          height: HEADER_HEIGHT,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          zIndex: (theme) => theme.zIndex.appBar - 1,
        }}
      >
        <Box pt={1}>
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            {currentUser && !currentUser?.public && !currentUser?.admin && (
              <Link href="/">My Reports</Link>
            )}
            {currentUser && !currentUser?.public && !currentUser?.admin && (
              <Link href={`/#/reports/${reportId}/`}>Report Overview</Link>
            )}
            <Typography>A PDF of your report is being compiled</Typography>
          </Breadcrumbs>
        </Box>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid
            item
            sx={{
              width: '100%',
            }}
          >
            <Box
              pb={2}
              sx={{
                fontWeight: 'bold',
                mt: 1,
              }}
            >
              <Typography
                noWrap
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 'bold',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {reportTitle}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Box sx={{ height: HEADER_HEIGHT }} />
    </>
  )
}

export default PdfReportNavbar
